export const legacyConsultantStatusRows = [
  { division:'Mock 기본 패키지',consultant:'Mock 상담자 A',consults:12,contracts:7,amount:4200000,card:2600000,cash:1600000 },
  { division:'Mock 성장 패키지',consultant:'Mock 상담자 B',consults:9,contracts:5,amount:3100000,card:2100000,cash:1000000 },
  { division:'-미등록-',consultant:'Mock 상담자 C',consults:4,contracts:1,amount:600000,card:400000,cash:200000 },
]
export const legacyConsultantOffices=['Mock 지점 01','Mock 지점 02']
